import { Patient } from "@/Common/Models/Patient/Patient";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";
import { BcCareConnectDomain } from "@/Patient/Models/BcCareConnect/BcCareConnect";

class BcCareConnectAction extends BaseAction {
    public CareConnect(patient: Patient, domain: BcCareConnectDomain): void {
        const integrationInfo = {
            phn: patient.IndividualResponse.NAM,
            fn: patient.IndividualResponse.FirstName,
            ln: patient.IndividualResponse.LastName,
            dob: LuxonDateTimeParser.parse(patient.IndividualResponse.DateOfBirth)?.toFormat("yyyyMMdd") ?? "",
            g: this.GetGender(patient.IndividualResponse.GenderLookupId),
            o: "phsa", // health authority - it is not a required field but if it pass empty doesn't find the patient
            d: domain.toString(),
            nav: "top"
        };

        this.RedirectToCareConnect(integrationInfo);
    }

    private RedirectToCareConnect(params: any): void {
        const tabName = "careconnect";
        const _myleCareConnectUri = cacheStore.ClinicSettingsServices.BcCareConnect;
        const form = document.createElement("form");
        form.setAttribute("method", "post");
        form.setAttribute("action", _myleCareConnectUri);
        form.setAttribute("target", tabName);

        form.onsubmit = function() {
            window.open("about:blank", tabName, "");
        };

        for (let key in params) {
            if (params.hasOwnProperty(key)) {
                const hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", key);
                hiddenField.setAttribute("value", params[key]);

                form.appendChild(hiddenField);
            }
        }

        document.body.appendChild(form);
        form.submit();
    }

    private GetGender(lookupId: string): string {
        const gender = cacheStore.GetLookupById(lookupId).LookupCode;
        switch (gender.toUpperCase()) {
            case "MALE":
                return "M";
            case "FEMALE":
                return "F";
            case "UNKNOWN":
                return "U";
            case "UNDIFFERENTIATED":
                return "UN";
            default:
                return null;
        }
    }
}

export { BcCareConnectAction };
